// extracted by mini-css-extract-plugin
module.exports = {"xs":"320","sm":"480","md":"768","lmd":"930","lg":"1024","xl":"1200","xxl":"1440","xxxl":"1900","fhd":"2560"};